import type { FaireProductEntity } from "../../entity_types/product";

export const p_55pprbav45: FaireProductEntity = {
  token: "p_55pprbav45",
  type: "product",
  name: "Trefl Red 500 Piece Jigsaw Puzzle - Grand Canyon USA",
  brandToken: "b_2gyr9m38qj",
  brandName: "Trefl USA",
  imageUrl:
    "https://cdn.faire.com/fastly/5cfb7d8abb8b489a4a4eff2242f1223517cc1a21467331dd45af6d4d2f2a40b2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cafbff21f06f02a9957293345f78286f623820293c74d53ce10c9e92159c4d2f.png",
    "https://cdn.faire.com/fastly/8a99983c27bdf2b50b1f0334c009a857320da9fb02a2809d80db083eef9b677c.png",
  ],
  priceDollars: 6.22,
  description:
    "Take on the challenge of assembling the Trefl Red Grand Canyon, Arizona puzzle! With 500 pieces, this puzzle beautifully captures the incredible landscape of the Canyon, complete with its majestic body of water, towering peaks and low valleys. Explore each intricate detail as you piece it together, and feel a sense of accomplishment once the puzzle is complete. \n\nTrying to arrange a nice evening at home? Jigsaw puzzles are a great way to spend your free time with friends and family, at the same time providing you with a great brain exercise. They also make for a perfect birthday or Christmas gift. Trefl jigsaw puzzles are produced in Poland using natural materials only.",
  tags: [],
  msrpDollars: 12.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:59.022Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
